export const generateFieldName = (
  entityName: string | undefined,
  fieldName: string,
): string => {
  if (entityName === undefined) {
    return fieldName;
  } else {
    return `${entityName}${fieldName[0].toUpperCase()}${fieldName.substring(
      1,
    )}`;
  }
};
